import React from 'react';
import PropTypes from 'prop-types';
import ConnectedProductionForm from './ConnectedProductionForm';

const ProductionRouting = ({ match }) => <ConnectedProductionForm />;

ProductionRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ProductionRouting;
